export const config = {
  ease: {
    smooth: "power2.out",
    bounce: "back.out(1.7)",
    snap: "expo.out",
    in: "power3.in",
    out: "power3.out",
    inOut: "expo.inOut",
    elastic: "elastic.out(1, 0.5)",
  },
  duration: {
    fast: 0.4,
    normal: 0.7,
    slow: 1.2,
    cinematic: 1.8,
  },
  stagger: {
    tight: 0.05,
    normal: 0.1,
    loose: 0.18,
  },
};
